import React from 'react';
import './Message.css';

const Message = ({ message }) => {
  const isBot = message.sender === 'bot';

  return (
    <div className={`message ${isBot ? 'message-bot' : 'message-user'} ${message.isTyping ? 'message-typing' : ''} ${message.isError ? 'message-error' : ''}`}>
      <div className="message-bubble">
        {message.isTyping ? (
          <div className="typing-indicator">
            <span></span>
            <span></span>
            <span></span>
          </div>
        ) : (
          <p className="message-text">{message.text}</p>
        )}
      </div>
    </div>
  );
};

export default Message;


